import axios from '../axios';
import { checkResponse } from '../utils';

const getCompany = () => {
  return axios.get(`/api/v1/sw/customer/current/company`).then(checkResponse);
};

const getServiceList = (companyId) => {
  return axios.get(`/api/v1/sw/company/service/list?companyId=${companyId}`).then(checkResponse);
};

const getStaffInfo = (companyId) => {
  return axios.get(`/api/v1/sw/staff/info/company?companyId=${companyId}`).then(checkResponse);
};

const createService = (companyId, serviceType) => {
  return axios
    .post(`/api/v1/sw/company/service/create?companyId=${companyId}&serviceType=${serviceType}`)
    .then(checkResponse);
};

const createCustomerService = (serviceType) => {
  return axios
    .post(`/api/v1/sw/company/customer/service/create?serviceType=${serviceType}`)
    .then(checkResponse);
};
// 创城-消息概况
const getInformOutLines = () => {
  return axios.get(`/api/v1/sw/inform/informOutLines`).then(checkResponse);
};
// // 创城-消息概况
// const getSearchInforms = () => {
//   return axios.get(`/api/v1/sw/inform/searchInforms`).then(checkResponse);
// };
// 标记消息已读
const readedNotice = (ids) => {
  return axios.post(`/api/v1/sw/inform/markInformAlreadyRead?informIds=${ids}`).then(checkResponse);
};
// 查询通知
const searchNotice = (info) => {
  return axios.get(`/api/v1/sw/inform/searchInforms`, { params: info }).then(checkResponse);
};

export {
  getCompany,
  getServiceList,
  getStaffInfo,
  createService,
  createCustomerService,
  getInformOutLines,
  // getSearchInforms,
  readedNotice,
  searchNotice,
};
